import { DOMParser as ProseMirrorDOMParser, type Schema, Slice } from "@tiptap/pm/model";
import { marked } from "marked";

const MARKDOWN_PATTERN = /^#{1,6}\s|^\s*[-*]\s|^\s*\d+\.\s|```|^\|.+\|$/m;
export const SKILL_MARKDOWN_MARKED_OPTIONS = {
  gfm: true,
  breaks: false,
};

export const looksLikeMarkdown = (text: string): boolean => MARKDOWN_PATTERN.test(text);

export const parseMarkdownToHtml = (text: string): string =>
  marked.parse(text, SKILL_MARKDOWN_MARKED_OPTIONS) as string;

export const parseTextToSlice = (text: string, schema: Schema): Slice => {
  if (!text.trim()) {
    return Slice.empty;
  }

  const html = parseMarkdownToHtml(text);
  const wrapper = globalThis.document.createElement("div");
  wrapper.innerHTML = html;

  const parsed = ProseMirrorDOMParser.fromSchema(schema).parse(wrapper);
  return parsed.content ? new Slice(parsed.content, 0, 0) : Slice.empty;
};

export const parseMarkdownToSlice = (text: string, schema: Schema): Slice => {
  if (!looksLikeMarkdown(text)) {
    return Slice.empty;
  }

  return parseTextToSlice(text, schema);
};
